import withSpacing from '../../decorators/withSpacing/index';
import Select from './Select';
export default withSpacing(Select);
//# sourceMappingURL=index.js.map